<template>
  <div
    id="multiSensorHiL"
    :class="{
      box: true,
      'landscape-box': isLandscape,
      'portrait-box': !isLandscape,
      en: $i18n.locale === 'en-US',
    }"
  >
    <!-- <div id="multiSensorHiL"> -->
    <div
      id="multiSensorHiLModule1"
      :style="{ 'background-image': 'url(' + imageUrl1 + ')' }"
      v-lazy="imageUrl1"
    >
      <div id="multiSensorHiLModule1Text" class="gaiAModule1">
        <div id="multiSensorHiLModule1TextText1" class="module1">
          {{ $t(`${i18nKey}.title`) }}
        </div>
        <div
          id="multiSensorHiLModule1TextText2"
          class="module1 pre-wrap"
          v-text="$t(`${i18nKey}.subtitle`)"
        ></div>
      </div>
    </div>

    <!-- 支持全场景自动驾驶解决方案 -->
    <div
      id="box_auto"
      :style="{ 'background-image': 'url(' + imageUrl2 + ')' }"
    >
      <div class="wow animate__animated animate__fadeInUp">
        <div class="box_title">{{ $t(`${i18nKey}.solution.title`) }}</div>
        <div class="box_subTitle">{{ $t(`${i18nKey}.solution.subtitle`) }}</div>
        <div class="box_imgAll">
          <div class="box_img">
            <div class="img_add_sub_name">
              <img class="img_img1" src="./1.png" alt="" />
              <div class="box_img_sub_name">
                {{ $t(`${i18nKey}.solution.list[0].title`) }}
              </div>
            </div>
            <div class="box_img_name">
              {{ $t(`${i18nKey}.solution.list[0].subtitle`) }}
            </div>
          </div>

          <div class="box_img">
            <div class="img_add_sub_name">
              <img class="img_img2" src="./2.png" alt="" />
              <div class="box_img_sub_name box_img_sub_name2">
                {{ $t(`${i18nKey}.solution.list[1].title`) }}
              </div>
            </div>
            <div class="box_img_name">
              {{ $t(`${i18nKey}.solution.list[1].subtitle`) }}
            </div>
          </div>

          <div class="box_img">
            <div class="img_add_sub_name">
              <img class="img_img" src="./3.png" alt="" />
              <div class="box_img_sub_name box_img_sub_name3">
                {{ $t(`${i18nKey}.solution.list[2].title`) }}
              </div>
            </div>

            <div class="box_img_name">
              {{ $t(`${i18nKey}.solution.list[2].subtitle`) }}
            </div>
          </div>

          <div class="box_img">
            <div class="img_add_sub_name">
              <img class="img_img2" src="./4.png" alt="" />
              <div class="box_img_sub_name box_img_sub_name4">
                {{ $t(`${i18nKey}.solution.list[3].title`) }}
              </div>
            </div>

            <div class="box_img_name">
              {{ $t(`${i18nKey}.solution.list[3].subtitle`) }}
            </div>
          </div>

          <div class="box_img">
            <div class="img_add_sub_name">
              <img class="img_img1" src="./5.png" alt="" />
              <div class="box_img_sub_name box_img_sub_name5">
                {{ $t(`${i18nKey}.solution.list[4].title`) }}
              </div>
            </div>

            <div class="box_img_name">
              {{ $t(`${i18nKey}.solution.list[4].subtitle`) }}
            </div>
          </div>
        </div>

        <div class="box_tip">* {{ $t(`${i18nKey}.solution.tip`) }}</div>
      </div>
    </div>

    <div id="multiSensorHiLFooter">
      <FooterComponents></FooterComponents>
    </div>
  </div>
</template>

<script>
import FooterComponents from "@/components/FooterComponents.vue";
import WOW from "wowjs";
// 首先引入element-ui中文包
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
// 然后将element-ui中pagination选项改掉
zhLocale.el.pagination = {
  pagesize: "/页",
  total: `共 {total} 条`,
  goto: "跳至",
  pageClassifier: "",
};
export default {
  computed: {
    isLandscape() {
      return Math.abs(window.orientation) === 90;
    },
  },
  components: {
    FooterComponents,
  },
  updated() {
    let lang = localStorage.getItem("lang");
    if (lang == "en-US") {
      this.showTestObject = false;
    } else {
      this.showTestObject = true;
    }
  },
  data() {
    return {
      i18nKey: "ecosphereFullScaleAutonomousDriving",
      imageUrl1: require("@/static/img/FullScaleAutonomousDrivingBanner.png"),
      imageUrl2: require("@/view/FullScaleAutonomousDriving/back.png"),
      showTestObject: true,
      //初始每页的数据条目数据
      pagesize: 10,
      // 前往1页
      currentPage: 1,
    };
  },
  created() {
    const reloadOnOrientationChange = () => {
      const isLandscape = Math.abs(window.orientation) === 90;
      if (isLandscape) {
        location.reload();
      } else {
        location.reload();
      }
    };
    window.addEventListener("orientationchange", reloadOnOrientationChange);
  },
  mounted() {
    window.addEventListener("scroll", this.scrolling);
    let lang = localStorage.getItem("lang");
    if (lang == "en-US") {
      this.showTestObject = false;
    } else {
      this.showTestObject = true;
    }
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
    // let liElementArr = this.$refs.liRef;
    // liElementArr.forEach((item, index) => {
    //   item.style.animationDuration = (index + 1) * 0.3 + "s";
    // });
  },
};
</script>

<style scoped lang="scss">
.landscape-box {
  /* 横屏 */
  /* display: flex;
  flex-direction: column; */
}

.portrait-box {
  /* 竖屏 */
  display: flex;
  flex-direction: column;
}

#multiSensorHiL {
  width: 100%;
  height: 100%;

  @mixin whar($width, $height, $atio) {
    width: $width;
    height: $height;
    aspect-ratio: $atio;
    box-sizing: border-box;
  }

  @mixin bgar($atio) {
    text-align: center;
    margin-right: 1.5rem;
    aspect-ratio: $atio;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @mixin display {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @mixin commitaspct {
    opacity: 1;
    width: 50%;
    aspect-ratio: 720/600;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @mixin fontStyle(
    $fontweight,
    $height,
    $fontSize,
    $lineHeight,
    $letterSpaceing,
    $color
  ) {
    width: fit-content;
    font-weight: $fontweight;
    height: $height;
    font-size: $fontSize;
    font-style: normal;
    line-height: $lineHeight;
    letter-spacing: $letterSpaceing;
    color: $color;
  }

  #multiSensorHiLModule1 {
    background-size: cover;
    @include whar(100%, auto, 1440/480);
    padding: 12.9375rem 12.9375rem 11rem 12.8125rem;

    #multiSensorHiLModule1Text {
      width: fit-content;
      height: 7.75rem;
      line-height: 3.875rem;

      #multiSensorHiLModule1TextText1 {
        @include fontStyle(
          600,
          3.875rem,
          2.5rem,
          3.875rem,
          0.06944rem,
          rgba(255, 255, 255, 0.85)
        );
      }

      #multiSensorHiLModule1TextText2 {
        opacity: 1;
        margin-top: 0.75rem;
        @include fontStyle(
          400,
          2rem,
          1.0625rem,
          2rem,
          0.06944rem,
          rgba(255, 255, 255, 0.65)
        );
      }
    }
  }

  /* 高精度仿真的自动驾驶“疆域” */
  #territory {
    width: 100%;
    // height: 100vh;

    box-sizing: border-box;
    background: url("@/static/img/territoryBox_bg.png") no-repeat;
    background-size: cover;

    #territoryBox {
      position: relative;
      width: 100%;
      // height: 100%;

      #title {
        position: absolute;
        top: 3.5rem;
        left: 50%;
        transform: translateX(-50%);
        color: rgba(255, 255, 255, 0.85);
        text-align: center;
        font-size: 2.25rem;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      #subTitle {
        position: absolute;
        top: 7.7rem;
        left: 50%;
        transform: translateX(-50%);
        color: rgba(255, 255, 255, 0.65);
        text-align: center;
        font-size: 1rem;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      #img {
        width: 100%;
        // width: 80rem;
        // height: 42.1875rem;
        height: 100%;
        top: 30rem;

        // margin: 0 auto;

        #video {
          width: 100%;
          height: 100%;
          // height: 100vh;
          object-fit: contain;
        }
      }
    }
  }

  // 合作咨询
  .collaborativeConsulting {
    padding: 4.875rem 13.75rem;

    .title1 {
      color: rgba(255, 255, 255, 0.85);
      text-align: center;
      font-size: 2.25rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    .title2 {
      color: rgba(255, 255, 255, 0.65);
      text-align: center;
      font-size: 1rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.625rem;
      margin: 1rem 0 2.5rem;
    }

    ul {
      li {
        .a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          padding: 2.5rem 0;
          border-bottom: 1px solid #282d45;

          .img {
            width: 16.75rem;
            height: 9.375rem;
            flex-shrink: 0;
            margin-right: 2rem;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .cont {
            .h1 {
              color: rgba(255, 255, 255, 0.85);
              font-size: 1rem;
              font-style: normal;
              font-weight: 500;
              line-height: 1.625rem;
            }

            .h2 {
              color: rgba(255, 255, 255, 0.65);
              text-align: justify;
              font-size: 0.875rem;
              font-style: normal;
              font-weight: 400;
              line-height: 1.75rem;
              margin: 0.75rem 0;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }

            .date {
              display: flex;
              color: rgba(255, 255, 255, 0.65);
              font-size: 0.875rem;
              font-style: normal;
              font-weight: 400;
              line-height: 1.75rem;

              /* 200% */
              .svg {
                width: 0.75rem;
                height: 0.75rem;
                margin-right: 0.3125rem;

                svg {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }
            }
          }
        }
      }
    }

    .pagination {
      padding: 2rem;
      text-align: center;

      ::v-deep .el-pagination.is-background .btn-prev {
        color: rgba(255, 255, 255, 0.65);
        border-radius: 2px;
        background-color: #0c132b;
        border: 1px solid rgba(255, 255, 255, 0.16);
      }

      ::v-deep .el-pagination.is-background .btn-next {
        color: rgba(255, 255, 255, 0.65);
        border-radius: 2px;
        background-color: #0c132b;
        border: 1px solid rgba(255, 255, 255, 0.16);
      }

      ::v-deep .el-pagination.is-background .el-pager li {
        border-radius: 2px;
        background-color: #0c132b;
        border: 1px solid rgba(255, 255, 255, 0.16);
        color: rgba(255, 255, 255, 0.65);

        &:hover {
          color: rgba(255, 255, 255, 0.65);
        }
      }

      ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        border-radius: 2px;
        border: 1px solid var(--Brand-6-normal, #d71f28);
        background: var(--Brand-6-normal, #d71f28);
      }

      ::v-deep .el-input__inner {
        color: rgba(255, 255, 255, 0.65);
        background-color: #0c132b;
        border: 1px solid rgba(255, 255, 255, 0.16);
      }

      ::v-deep .el-pagination__jump {
        margin-left: 0;
      }
    }
  }
}

#box_auto {
  width: 100%;
  //background: #fff;
  //background-image: url("./back.png");
  background-position: center center;
  /* 背景图不平铺 */
  background-repeat: no-repeat;
}

.box_title {
  margin-top: 5rem;
  margin-bottom: 1rem;
  color: rgba(255, 255, 255, 0.85);
  text-align: center;
  font-size: 2.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.box_subTitle {
  color: rgba(255, 255, 255, 0.65);
  margin-bottom: 1rem;
  text-align: center;
  font-size: 1rem;
  font-style: normal;
  //font-weight: 600;
  line-height: normal;
}

.box_imgAll {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box_img {
  display: inline-block;
  width: 13rem;
  margin: 0 0.25rem;
  text-align: center;
}

.img_img {
  width: 13rem;
  height: 23rem;
  vertical-align: middle;
}

.img_img1 {
  width: 13rem;
  height: 26.3rem;
  vertical-align: middle;
}

.img_img2 {
  width: 13rem;
  height: 24rem;
  vertical-align: middle;
}

.img_add_sub_name {
  position: relative;
}
.box_img_sub_name {
  font-weight: 600;
  position: absolute;
  color: rgba(255, 255, 255, 0.85);
  bottom: 0;
  left: 50%;
  font-size: 0.9rem;
  transform: translateX(-50%);
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 6.3rem;
}

.box_imgAll {
  .box_img {
    &:nth-child(2),
    &:nth-child(4) {
      .box_img_sub_name {
        height: 5.6rem;
      }
    }
    &:nth-child(3) {
      .box_img_sub_name {
        height: 5.3rem;
      }
    }
  }
}

.box_img_sub_name2 {
  //bottom:8.74rem;
}
.box_img_sub_name3 {
  //bottom:9.74rem;
}
.box_img_sub_name4 {
  //bottom:8.74rem;
}
.box_img_sub_name5 {
  //bottom:6.74rem;
}

.box_img_name {
  //position: absolute;
  font-size: 0.8rem;
  margin-top: 1.5rem;
  //bottom: -1.5rem;
  color: rgba(255, 255, 255, 0.85);
}
.box_tip {
  text-align: center;
  margin-top: 4.06rem;
  font-size: 0.4rem;
  color: rgba(255, 255, 255, 0.45);
  margin-bottom: 1rem;
}

.en {
  #multiSensorHiLModule1TextText2,
  .box_img_sub_name,
  .box_img_name {
    line-height: 1.5 !important;
  }
}
</style>
